import styled, { css } from 'styled-components';
import { Form as Unform } from '@unform/web';
import { Button } from '../../components';

export const Form = styled(Unform)`
  margin-top: -2rem;
  padding: 0 4rem;

  @media (max-width: 600px) {
    padding: 0 0.8rem;
  }
`;

export const Card = styled.div`
  background-color: #fff;
  border-radius: 0.8rem;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
  padding: 2.4rem;
  margin-bottom: 1.6rem;

  fieldset {
    display: flex;
    flex-direction: column;
    /* align-items: stretch; */

    border-radius: 0.8rem;
    border-color: #c4c4c4;
    border-style: solid;
    border-width: 1px;
    padding: 1rem;

    legend {
      margin-left: 2rem;
      padding: 0.8rem;
      font-size: 1.4rem;
      color: #6c6c6c;
    }
  }
`;

export const ImagePreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 2px dashed #ddd;
  border-radius: 8px;
  padding: 0.8rem;
  margin-bottom: 0.8rem;
`;

export const InputColumnGroupGrid = styled.div<{ cols: number }>`
  ${({ cols }) => css`
    display: grid;
    grid-template-columns: repeat(${cols}, 1fr);
    grid-gap: 2rem;

    & + div {
      margin-top: 2rem;
    }

    fieldset {
      flex: auto;

      &[disabled] {
        opacity: 0.4;
      }
    }

    @media (max-width: 1200px) {
      grid-template-columns: 1fr;
    }
  `}
`;

export const CardTitle = styled.h5`
  margin-bottom: 1.6rem;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 1.6rem;

  @media (max-width: 600px) {
    /* justify-content: space-between; */
    align-items: stretch;
  }
`;

export const InputRowGroup = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: baseline;
  justify-content: space-between;

  input {
    max-width: 10rem;
  }

  @media (max-width: 600px) {
    flex-direction: column;

    div {
      width: 100%;
      margin-bottom: 2rem;

      input {
        max-width: unset;
        width: 100%;
      }
    }
  }

  @media (min-width: 601px) and (max-width: 1200px) {
    justify-content: unset;
    display: grid;
    grid-template-columns: repeat(3, auto);
    gap: 0.8rem;

    div {
      /* margin-top: 0.8rem; */
      width: 100%;
      margin-bottom: 0.8rem;

      input {
        max-width: unset;
        width: 100%;
      }
    }
  }

  @media (min-width: 1201px) {
    div {
      margin-right: 0.8rem;
      width: 100%;

      input {
        max-width: unset;
        width: 100%;
      }
    }

    > div:last-of-type {
      margin-right: unset;
    }
  }
`;

export const InputGroupColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  width: 100%;
`;

export const InputGroupBetween = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 600px) {
    align-items: stretch;
    flex-direction: column;

    > div {
      margin-bottom: 1.6rem;
    }
  }
`;

export const PrismContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  fieldset {
    flex-direction: row;

    > div:nth-child(2) {
      margin-right: 1rem;
    }

    &[disabled] {
      opacity: 0.4;
    }
  }

  @media (max-width: 900px) {
    align-items: stretch;
    flex-direction: column;

    fieldset {
      flex-direction: column;

      > div:nth-child(2) {
        margin-right: unset;
        margin-bottom: 1rem;
      }
    }
  }
`;

export const ShowImagesGridButton = styled(Button)`
  margin-top: auto;
  margin-bottom: 1rem;
  white-space: nowrap;
`;

export const ModelImagesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

interface ModelImageSelectorProps {
  isSelected: boolean;
}

export const ModelImageSelector = styled.div<ModelImageSelectorProps>`
  cursor: pointer;
  transition: filter 200ms;
  display: flex;
  filter: ${({ isSelected }) =>
    isSelected ? 'brightness(0.9)' : 'brightness(1)'};

  img {
    border-radius: 0.8rem;
  }

  &:hover {
    filter: brightness(0.9);
  }
`;

export const ConfirmDataContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.2fr 1fr;
  column-gap: 1rem;

  fieldset {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 1rem;
    border-radius: 0.8rem;
    border-color: #c4c4c4;
    border-style: solid;
    border-width: 1px;
    padding: 1rem;
    flex-wrap: wrap;

    legend {
      margin-left: 2rem;
      padding: 0 0.8rem;
      font-size: 1.4rem;
      color: #6c6c6c;
    }

    div {
      margin-right: 1rem;
    }
  }

  > button {
    width: 100%;
  }

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const SalesmanButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: auto;

  button {
    margin-left: 0.5rem;
    flex-grow: 1;
  }

  @media (max-width: 600px) {
    margin-top: 2rem;

    button:first-of-type {
      margin-left: 0;
    }
  }
`;

export const InputButtonGroup = styled.div`
  display: flex;
  flex-direction: row;

  div:first-of-type {
    width: 100%;
  }

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;
